import * as React from 'react';

export default (props:any) => (
    <svg
        width={32}
        height={32}
        viewBox="0 0 20 18"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <g id="Page-1" stroke="none" strokeWidth="1" fillRule="evenodd">
            <path
                d="M10,16 L18,16 L18,6 L10,6 L10,4 L20,4 L20,18 L10,18 L10,16 Z M10,8 L12,8 L12,10 L10,10 L10,8 Z M14,8 L16,8 L16,10 L14,10 L14,8 Z M10,12 L12,12 L12,14 L10,14 L10,12 Z M14,12 L16,12 L16,14 L14,14 L14,12 Z"></path>
            <path
                d="M0,0 L10,0 L10,18 L0,18 L0,0 Z M2,2 L2,4 L4,4 L4,2 L2,2 Z M6,2 L6,4 L8,4 L8,2 L6,2 Z M2,6 L2,8 L4,8 L4,6 L2,6 Z M6,6 L6,8 L8,8 L8,6 L6,6 Z M2,10 L2,12 L4,12 L4,10 L2,10 Z M6,10 L6,12 L8,12 L8,10 L6,10 Z M2,14 L2,16 L4,16 L4,14 L2,14 Z M6,14 L6,16 L8,16 L8,14 L6,14 Z"></path>
        </g>
    </svg>
);
